import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { connect, useDispatch, useSelector } from "react-redux";
import EditPopUpAdmin from "./EditPopUpAdmin";
import Swal from "sweetalert2";
import axios from "axios";
import { ACTUALIZAR_LISTA } from "../../../../redux/constanst";
import { Button } from "@mui/material";
import { hosting } from "../../models/buscar";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function ListaEdit({ data }) {
  const dispatch = useDispatch();
  const { actualizarLista } = useSelector((state) => state.userState);
  const alerta = (datos) => {
    Swal.fire({
      title: `¿Seguro que quiere eliminar a ${datos.name}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(
            `${hosting}/mimegacall/api/delete_tarifa.php?ratesid=${datos.ratesid}`
          )
          .then((response) => {
            Swal.fire(response.data.mensaje, ``, `${response.data.type}`).then(
              (result) => {
                dispatch({
                  type: ACTUALIZAR_LISTA,
                  actualizarLista: !actualizarLista,
                });
              }
            );
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    });
  };
  return (
    <div  style={{
      padding: '4% 4%',
    }}>
    <TableContainer component={Paper}>
      <Table
        sx={{ maxWidth: "100%", flex: 1, width: "100%" }}
        aria-label="customized table"
      >
        <TableHead style={{ background: "red" }}>
          {data.tarifa.length > 0 ? (
            <TableRow>
              <StyledTableCell style={{ backgroundColor: "#F4796D" }}>
                Nombre
              </StyledTableCell>
              <StyledTableCell
                style={{ backgroundColor: "#F4796D" }}
                align="right"
              >
                Prefijo
              </StyledTableCell>
              <StyledTableCell
                style={{ backgroundColor: "#F4796D" }}
                align="right"
              >
                Costo
              </StyledTableCell>
              <StyledTableCell
                style={{ backgroundColor: "#F4796D" }}
                align="right"
              ></StyledTableCell>
              <StyledTableCell
                style={{ backgroundColor: "#F4796D" }}
                align="left"
              ></StyledTableCell>
            </TableRow>
          ) : (
            <TableRow>
              <StyledTableCell style={{ backgroundColor: "grey" }}>
                Sin tarifa
              </StyledTableCell>
              <StyledTableCell
                style={{ backgroundColor: "grey" }}
                align="left"
              >
              
              </StyledTableCell>
            </TableRow>
          )}
        </TableHead>
        <TableBody>
          {data.tarifa.map((dato) => (
            <StyledTableRow>
              <StyledTableCell component="th" scope="row">
                {dato.name}
              </StyledTableCell>
              <StyledTableCell align="right">{dato.prefix}</StyledTableCell>
              <StyledTableCell align="right">{dato.cost.replace(".",",")}</StyledTableCell>

              <StyledTableCell align="right"></StyledTableCell>
              <StyledTableCell
                align="right"
                style={{
                  display: "flex",
                  textAlign: "right",
                }}
              >
                <EditPopUpAdmin
                  style={{
                    height: 30,
                    marginLeft: 1,
                    marginRight: 1,
                    marginBottom: 1,
                    backgroundColor: "#009966",
                  }}
                  btnLabel={"Editar tarifa"}
                  datos={dato}
                />
                <Button
                    style={{
                      width: "auto",
                      height: "auto",
                      backgroundColor: "red",
                      marginLeft: 20,
                      marginRight: 20,
                      marginBottom: 20,
                    }}
                    onClick={() => alerta(dato)}
                    variant="contained"
                  >
                    <p style={{ fontSize: 10 }}>ELIMINAR TARIFA</p>
                  </Button>
                
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
  );
}
const mapStateToProps = (store) => ({});

export default connect(mapStateToProps, null)(ListaEdit);
